<input class="form-control" type="text" [(ngModel)]="observation.title" (keyup)="onChangeDebounced()">